<template>
  <div id="app" v-show="redirection">
    <!-- <vue-progress-bar></vue-progress-bar> -->
    <div v-if="isPaymentPage">
      <header-logged-in :status=navStatus></header-logged-in>
      <!-- <vue-progress-bar></vue-progress-bar> -->
    </div>
      <router-view></router-view>
      <footerArea></footerArea>

  </div>
</template>

<script>
import {INSTANCE_NAME} from '@/components/common/constants.js'
import { EventBus } from '@/main.js'
import headerLoggedIn from './components/common/headerLogin'
import footerArea from './components/common/footerArea'
export default {
  name: 'app',
  components: {
    headerLoggedIn,
    footerArea
  },
  data () {
    return {
      instanceName: INSTANCE_NAME,
      navStatus: ''
    }
  },
  computed: {
    isPaymentPage: function () {
      if (this.$route.name === 'success') {
        return false
      }
      return true
    },
    redirection: function () {
      window.scrollTo(0, 0)
      this.start()
      var form = this
      if (this.$route.path !== 'This/Is/Never/Gonna/Match') {
        // alert(JSON.stringify(this.$route.path.split('/')))
        if (!(this.$route.path === '/' || this.$route.path === '/home' || this.$route.path === '/advertisement' || this.$route.path === '/searchPageAlt' || this.$route.path.split('/')[1] === 'coursePage')) {
          var token = window.MKCLAPI.getToken()
          // var token = form.$store.getters.getToken
          window.MKCLAPI.isTokenValid(token)
            .then(function () {})
            .catch(function () {
              form.$router.push({ path: '/home' })
              // form.$toasted.info('Session Expired. Please login again.')
              window.MKCLAPI.login()
            })
        }
      }
      return true
    }
  },
  methods: {
    start () {
      this.$Progress.start()
    },
    set (num) {
      this.$Progress.set(num)
    },
    increase (num) {
      this.$Progress.increase(num)
    },
    decrease (num) {
      this.$Progress.decrease(num)
    },
    finish () {
      this.$Progress.finish()
    },
    fail () {
      this.$Progress.fail()
    }
    // test () {
    //   this.$Progress.start()
    //   this.$http.jsonp('http://api.rottentomatoes.com/api/public/v1.0/lists/movies/in_theaters.json?apikey=7waqfqbprs7pajbz28mqf6vz')
    //   .then((response) => {
    //     this.$Progress.finish()
    //   }, (response) => {
    //     this.$Progress.fail()
    //   })
    // }
  },
  created () {
    EventBus.$on('showNav', data => {
      this.navStatus = data
    })
  },
  mounted () {
    document.getElementsByTagName('title')[0].innerHTML = this.instanceName
    if (this.instanceName === 'MAHADEMY') {
      document.getElementById('favIcon').href = 'static/assets/images/mahademyFavIcon.ico'
    } else {
      document.getElementById('favIcon').href = 'static/assets/images/favicon.ico'
    }
  }
}
</script>


<!-- <style lang="scss">
@import '../static/assets/styles/scss/template.scss';
</style> -->





// WEBPACK FOOTER //
// src/App.vue?0ced4110